import type { Prayer } from '@/types/prayer';
import { whoOf } from './prayer-utils';

const DISCOVERY_KEY = 'adia-last-discovery';
const MIN_DAYS_BETWEEN = 7;
const MIN_MONTHS_PRAYING = 2;

export interface DiscoveryMoment {
  who: string;
  months: number;
  prayerId: string;
}

export function checkDiscoveryMoment(prayers: Prayer[]): DiscoveryMoment | null {
  const lastShown = localStorage.getItem(DISCOVERY_KEY);
  if (lastShown) {
    const daysSince = (Date.now() - new Date(lastShown).getTime()) / 86400000;
    if (daysSince < MIN_DAYS_BETWEEN) return null;
  }

  const now = Date.now();
  let best: DiscoveryMoment | null = null;
  let bestMonths = 0;

  for (const p of prayers) {
    const who = whoOf(p);
    if (who === 'General') continue;
    const months = Math.floor((now - new Date(p.createdAt).getTime()) / (30 * 86400000));
    if (months >= MIN_MONTHS_PRAYING && months > bestMonths) {
      bestMonths = months;
      best = {
        who: who === 'Self' ? 'you' : who,
        months,
        prayerId: p.id,
      };
    }
  }

  return best;
}

export function markDiscoveryShown(): void {
  localStorage.setItem(DISCOVERY_KEY, new Date().toISOString());
}
